import {TimesheetEntryRepository} from "../TimesheetEntryRepository.js";

export class ClickUpTimesheetEntryRepository extends TimesheetEntryRepository {

    /**
     * @private {ClickUpClient}
     */
    _client;

    /**
     * @private {CustomerRepository}
     */
    _customerRepo;

    /**
     * @private {Promise<string[]>}
     */
    _workspaceIdProvider;

    /**
     * @type {string[]}
     * @private
     */
    _workspaceIds = [];

    /**
     * @type {string}
     * @private
     */
    _clientListID = "";

    /**
     * @param {ClickUpClient} client
     * @param {CustomerRepository} customerRepository
     * @param {Promise<string[]>} workspaceIdProvider
     * @param clientListID
     */
    constructor(client, customerRepository, workspaceIdProvider, clientListID) {
        super();
        this._workspaceIdProvider = workspaceIdProvider;
        this._client = client;
        this._clientListID = clientListID;
        this._customerRepo = customerRepository;

    }

    /**
     * @param {Date} start
     * @param {Date} end
     * @return {Promise<TimesheetEntry[]>}
     */
    async getDuring(start, end) {

        let customers = await this._customerRepo.all();

        /** @type {TimesheetEntry[]} **/
        let entries = [];
        for (let workSpaceId of await this._getFromWorkspaceIdProvider()) {
            for (let clickUpEntry of await this._client.getTimeEntries(workSpaceId, start, end)) {
                if (!clickUpEntry.task || !clickUpEntry.task.id) {
                    console.warn('ClickUp time entry without a task', clickUpEntry.id);
                    continue;
                }
                this._assignToCustomer(clickUpEntry, customers, workSpaceId);
                entries.push(clickUpEntry)
            }
        }
        return entries;
    }



    async getRunningEntries() {
        /** @type {TimesheetEntry[]} **/
        let entries = [];
        let customers = await this._customerRepo.all();

        for (let workSpaceId of await this._getFromWorkspaceIdProvider()) {
            let clickUpEntry = await this._client.getRunningEntry(workSpaceId);

            if (!clickUpEntry) {
                continue;
            }
            this._assignToCustomer(clickUpEntry, customers, workSpaceId);

            entries.push(clickUpEntry);

        }
        return entries;
    }

    _assignToCustomer(clickUpEntry, customers, workSpaceId) {
        for(let customer of customers) {
            if (customer.workspaceId && customer.workspaceId === workSpaceId) {
                clickUpEntry.task.customer = customer;
                return;
            }
            if (!clickUpEntry.task || !clickUpEntry.task.parent || !clickUpEntry.task.parent.parent) {
                console.warn('No parent list and folder to associate task with customer:', clickUpEntry);
                return;
            }
            if (clickUpEntry.task.parent.parent.name === customer.folderName) {
                clickUpEntry.task.customer = customer;
                return;
            }
        }
    }

    /**
     * @return {Promise<string[]>}
     * @private
     */
    async _getFromWorkspaceIdProvider() {
        if (this._workspaceIds && this._workspaceIds.length > 0) {
            return this._workspaceIds;
        }
        if (!this._workspaceIdProvider) {
            throw new Error('No workspaceId provider assigned.');
        }
        this._workspaceIds = await this._workspaceIdProvider;
        return this._workspaceIds;

    }
}